<template>
  <div class="m2 p3 white-bg">
    <div v-if="event === 'done'" class="flex justify-center flex-wrap">
      <span class="col-12 center"> {{ getReferencelabel("TRANSFER_OF") }} {{ amount }} {{ getReferencelabel("PROCEED_TO_WALLET") }} </span>
      <h1 class="col-12 center"> {{ wallet.balance }}€</h1>
      <div class="col-12 flex justify-center items-center circle black-bg" style="width:200px; height:200px;"> <i class="icon-check white" style="font-size:155px;"> </i>  </div>
    </div>

    <div v-if="event === 'refuse'" class="flex justify-center flex-wrap center">
      <span class="col-12 "> {{ getReferencelabel("TRANSFER_REJECTED") }} </span>
      <h1 class="col-12 "> {{ getReferencelabel("ERROR_CONNECTION") }} </h1>
      <i class="col-12 icon-attention" style="font-size:155px;"> </i>

    </div>
    <div class="flex justify-center pt3">
      <Button reference="USE_ELECTRONIC_WALLET" class="col-12 md-col-4 pl0 md-pl1 border-none mt3" btn-color="blue" :action="backToCarryWallet" />
    </div>
  </div>
</template>
<script>

import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Button from '@/components/elements/Button';
import { getReferencelabel } from '@/mixins/utils';

export default {

  components: { Button },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const reference = route.query.reference.split('|');
    const montant = parseInt(route.query.montant) || 0;
    const { event } = route.query;
    const wallet = store.state.wallets.find(a => a.uuid === reference[2]);
    const amount = (montant / 100).toFixed(2);

    function backToCarryWallet () {
      router.push({ name: 'Wallets List', params: { id: wallet.uuid }, hash:`#${wallet.uuid}` });
    }

    return { event, amount, wallet, backToCarryWallet, getReferencelabel };
  }
};
</script>
